// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gHhu","title":"styles_title__2eEWE"};